@use "styles" as *;

$block: me-card;

.#{$block} {
  display: block;
  position: relative;
  border-radius: $border-radius;
  border: $me-card-border-width solid $color-gray-300;
  background: $color-background-contrast;

  &__header, &__footer {
    margin: space(0, 5);
    padding: space(3, 0);

    @include remove-first-and-last-child-margins;
  }

  &__header {
    border-bottom: 1px solid $color-gray-300;
  }

  &__footer {
    border-top: 1px solid $color-gray-300;
  }

  &__body {
    padding: space(5);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: space(5);
  }

  &__content {
    flex: 1;
    max-width: 100%;

    @include remove-first-and-last-child-margins;
  }

  &__chip {
    position: absolute;
    top: space(-4);
    right: space(5);
  }

  &__header:empty,
  &__footer:empty,
  &__icon-right:empty,
  &__chip:empty {
    display: none;
  }

  &--link, &--shadow {
    box-shadow: $box-shadow;
    border-color: transparent;
  }

  &--link {
    cursor: pointer;
  }

  &--primary {
    background-color: $color-primary;

    & .#{$block} {
      &__header, &__footer {
        border-color: $color-text-highlight;
      }
    }

    & .#{$block}__header *, .#{$block}__body *, .#{$block}__footer * {
      color: $color-text-highlight;
    }
  }

  &--highlighted {
    box-shadow: $box-shadow;
    border-color: $color-primary;
  }

  &--paywall {
    overflow: hidden;
    border: none;
    box-shadow: $box-shadow;

    .#{$block} {
      &__header {
        background-color: $color-primary;
        color: $color-background;
        margin: 0;
        border: none;
      }

      &__body {
        padding-top: space(7);
        padding-bottom: space(7);
      }
    }
  }
}
